// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YyaG","importantInfo":"styles_importantInfo__105h9"};